import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.object.assign.js";

/*
 * Please be aware that the answers *should only be used* to store responses to questions in the questions module.
 * *That* is the definition of an 'answer' with respect to this module.
 */
import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import { FIB } from "../../config/constants";
var QUESTION_TYPE = FIB.QUESTION_TYPE,
    INDICATOR_KIND = FIB.INDICATOR_KIND;
import QuestionTypes from "../helpers/questionTypes";
import { passesIndicatorRule } from "../helpers/rules";

var defaultState = function defaultState() {
  return {
    // responses is used as a generic key-value store by many FC components, but we indicate specifically
    // which responses are at the higher, bona-fide question level which we're usually more interested in.
    responses: {},
    responsesUpdated: 0,
    recommendSuggestionResponse: undefined
  };
};

var state = defaultState();
var getters = {
  responses: function responses(state) {
    var responses = {};
    Object.keys(state.responses).map(function (key) {
      responses[key] = state.responses[key].value;
    });
    return responses;
  },
  responsesSections: function responsesSections(state) {
    var sections = [];
    Object.keys(state.responses).forEach(function (key) {
      sections.push(state.responses[key].meta.section.name);
    });
    return _toConsumableArray(new Set(sections));
  },
  responsesUpdated: function responsesUpdated(state) {
    return state.responsesUpdated;
  },

  /**
   * Gets the responses directly attributed to FIBQuizScreen & any other survey questions; provided for the Questions module only.
   * There exist other FC 'intermediate' answers stored in answers.responses - they shouldn't be, but they are.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Array} Array of responses
   */
  questions: function questions(state) {
    return Object.values(state.responses).filter(function (response) {
      return response.fromQuestion;
    });
  },

  /**
   * Parses question responses into answers
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Array} Array of parsed answers
   */
  answers: function answers(state, getters) {
    return QuestionTypes.parseAnswers();
  },

  /**
   * Attempt to find the answer to a survey question. Don't do this using the `answers` index
   * as it's very flaky and not consistent over question types for some bizarre reason.
   */
  getAnswerBySurveyQuestionId: function getAnswerBySurveyQuestionId(state) {
    return function (questionId) {
      return Object.values(state.responses).find(function (a) {
        var _a$meta, _a$meta$question;

        return (a === null || a === void 0 ? void 0 : (_a$meta = a.meta) === null || _a$meta === void 0 ? void 0 : (_a$meta$question = _a$meta.question) === null || _a$meta$question === void 0 ? void 0 : _a$meta$question.id) === questionId;
      });
    };
  },

  /**
   * Returns all answers of a given type
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Array} All such answers of a given type
   */
  filterAnswersByType: function filterAnswersByType(state, getters) {
    return function (type) {
      return getters.answers.filter(function (a) {
        return a.type === type;
      });
    };
  },

  /**
   * Returns the first answer of a given type, else undefined.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   *
   * @returns {Array} The first answer of a given type, else undefined
   */
  firstAnswerOfType: function firstAnswerOfType(state, getters) {
    return function (type) {
      return getters.answers.find(function (a) {
        return a.type === type;
      });
    };
  },

  /**
   * Get the score for a given indicator id. This function correctly abstracts over the weirdness the
   * frontend has, where NPS & CSAT are considered 'indicators', with their own ids; when really, they're
   * just derived from the 'real' headline indicators: Food, Drink etc.
   *   Please reuse this logic for getting scores, rather than re-implementing this elsewhere.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex module root state
   * @param {Object} rootGetters Vuex module root getters
   *
   * @param {Number} indicatorId Indicator id
   *
   * @returns {Number} The indicator score, else null if none is available.
   */
  getIndicatorScoreById: function getIndicatorScoreById(state, getters, rootState, rootGetters) {
    return function (indicatorId) {
      var _indicators$indicator, _getters$firstAnswerO, _getters$firstAnswerO2;

      // First we need to resolve what we're looking at from the indicator definitions
      var indicator = getters.getIndicatorById(indicatorId);

      if (!indicator) {
        return null;
      } // get all indicator answers so we can get the scores from them


      var indicators = getters.firstAnswerOfType('indicators'); // If it's a headline indicator, that's easy, you just look up the score by id.
      // Else, use the getters which derive scores from the indicators.

      switch (indicator.kind) {
        case INDICATOR_KIND.SURVEY_RATING:
          return (indicators === null || indicators === void 0 ? void 0 : (_indicators$indicator = indicators.indicators.find(function (h) {
            return h.meta.indicator.id == indicatorId;
          })) === null || _indicators$indicator === void 0 ? void 0 : _indicators$indicator.value) || null;

        case INDICATOR_KIND.CSAT:
          return (indicators === null || indicators === void 0 ? void 0 : indicators.csat) || null;

        case INDICATOR_KIND.NPS:
          return (_getters$firstAnswerO = (_getters$firstAnswerO2 = getters.firstAnswerOfType('nps')) === null || _getters$firstAnswerO2 === void 0 ? void 0 : _getters$firstAnswerO2.nps) !== null && _getters$firstAnswerO !== void 0 ? _getters$firstAnswerO : null;
        // use ?? to determine when to use the fallback instead of || as 0 is a valid value for NPS.
      }
    };
  },

  /**
   * Determines if conditions have been met to determine to pass the Manager Feedback indicator rule.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex module root state
   * @param {Object} rootGetters Vuex module root getters
   *
   * @returns {Boolean}
   */
  managerFeedbackIndicatorRulePassed: function managerFeedbackIndicatorRulePassed(state, getters, rootState, rootGetters) {
    var managerFeedback = rootGetters['questions/getSurvey'].managerFeedback;
    return managerFeedback.enabled && passesIndicatorRule(managerFeedback.indicatorRule);
  },

  /**
   * Determines if conditions have been met to determine that a guest is complaining about their experience.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex module root state
   * @param {Object} rootGetters Vuex module root getters
   *
   * @returns {Boolean} Returns true if the survey is regarded as a complaint, else false.
   */
  hasComplaint: function hasComplaint(state, getters, rootState, rootGetters) {
    var survey = rootGetters['questions/getSurvey']; // TODO: Fix this at some stage
    // We don't recognize complaints when complaint handling has been turned off:

    if (!survey.managerFeedback.enabled) {
      return false;
    } // A survey is regarded as a complaint if any of the following conditions are met...
    // A) Manager feedback indicator rule passed:


    if (getters.managerFeedbackIndicatorRulePassed) {
      return true;
    } // B) Drilldown Plus question content left:
    // Check to see if a DD+ question has been answered with a selected topic.


    var drilldownPlusTopicAnswers = getters.filterAnswersByType(QUESTION_TYPE.QUESTION_TYPE_DRILLDOWN_PLUS).filter(function (q) {
      return q.question.triggerComplaint && q.topics;
    });

    if (drilldownPlusTopicAnswers.length) {
      return true;
    } // Else, we don't think they're complaining about anything!


    return false;
  },

  /**
   * Determines if recommendation *would* be permitted for this piece of feedback after the point of submission.
   *
   * This is different from determining if recommendation *would* be permitted *and* the act of recommending
   * *would* be possible (e.g. emailing the scorecard link), which requires checking if the feedback
   * has been submitted yet. We intentionally don't return that as if this function is used at submission
   * time, this would always return false (as it hasn't been submitted yet)!
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex module root state
   * @param {Object} rootGetters Vuex module root getters
   *
   * @returns {Boolean}
   */
  recommendationPermitted: function recommendationPermitted(state, getters, rootState, rootGetters) {
    var aiRecommendation = rootGetters['questions/getSurvey'].aiRecommendation;

    if (!(aiRecommendation !== null && aiRecommendation !== void 0 && aiRecommendation.suggestionsEnabled)) {
      return false;
    }

    var aiSharingLink = rootGetters['config/getBranchDetails'].aiSharingLink; // This needs to be a boolean as it gets submitted to the API and the schema requires a boolean.

    return !!(getters.sharingPermitted && aiSharingLink);
  },

  /**
   * Determine if the survey responses have passed the recommendation settings indicator rule to enable the user to proceed to the AI recommendation page
   *
   * @param {Object} state
   * @param {Object} getters
   * @param {Object} rootState
   * @param {Object} rootGetters
   *
   * @returns {Boolean}
   */
  recommendationRulePassed: function recommendationRulePassed(state, getters, rootState, rootGetters) {
    var recommendation = rootGetters['questions/getSurvey'].recommendation;
    var indicatorRule = recommendation.indicatorRule; // if no rules are set then we treat the survey as passing in order to proceed to the ai recommendation page

    if (!(indicatorRule !== null && indicatorRule !== void 0 && indicatorRule.indicatorId) || [null, undefined].includes(indicatorRule === null || indicatorRule === void 0 ? void 0 : indicatorRule.scoreRequired)) {
      return true;
    } // return a boolean describing that the recommendation rule has passed


    return passesIndicatorRule(recommendation === null || recommendation === void 0 ? void 0 : recommendation.indicatorRule);
  },
  sharingPermitted: function sharingPermitted(state, getters) {
    return getters.doesPlatformSupportRecommendationOrSharing;
  },
  doesPlatformSupportRecommendationOrSharing: function doesPlatformSupportRecommendationOrSharing(state, getters, rootState, rootGetters) {
    var _rootGetters$checkIn;

    return (// We're not emulating being installed on a tablet.
      !((_rootGetters$checkIn = rootGetters['checkIn/urlParams']) !== null && _rootGetters$checkIn !== void 0 && _rootGetters$checkIn.inBranch) && // We're not _actually_ installed on a tablet.
      !rootGetters['config/isApp']
    );
  },

  /**
   * Determines if conditions have been met to send feedback alerts concerning this piece of feedback.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex module root state
   * @param {Object} rootGetters Vuex module root getters
   *
   * @returns {Boolean} Returns true if the feedback alerts should be left for the response, else false.
   */
  feedbackAlerts: function feedbackAlerts(state, getters) {
    // For consistency with the legacy guest, this is the same as if the conditions for a complaint are met (but don't require the guest to have left contact details)
    return getters.hasComplaint;
  },

  /**
   * Get the score for a given indicator id. This function correctly abstracts over the weirdness the
   * frontend has, where NPS & CSAT are considered 'indicators', with their own ids; when really, they're
   * just derived from the 'real' headline indicators: Food, Drink etc.
   *
   * @param {Object} state Vuex module state
   * @param {Object} getters Vuex module getters
   * @param {Object} rootState Vuex module root state
   * @param {Object} rootGetters Vuex module root getters
   *
   * @param {Number} indicatorId Indicator id
   *
   * @returns {Object} The indicator, else null if none is available.
   */
  getIndicatorById: function getIndicatorById(state, getters, rootState, rootGetters) {
    return function (indicatorId) {
      var survey = rootGetters['questions/getSurvey'];
      return survey.indicators.find(function (i) {
        return i.id === indicatorId;
      }) || null;
    };
  }
};

var buildResponse = function buildResponse(payload) {
  return _objectSpread(_objectSpread({}, payload), payload.fromQuestion ? {
    meta: _objectSpread(_objectSpread({}, payload.meta), {}, {
      value: payload.value
    })
  } : {});
};

var mutations = {
  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   *
   * @param {Object} state vuex state
   * @param {Object} payload payload
   * @param {Object} payload.question mi question
   * @param {Object} payload.rating mi rating
   *
   * @returns {Void}
   *
   */
  setMenuInsightResponse: function setMenuInsightResponse(state, _ref) {
    var question = _ref.question,
        rating = _ref.rating;
    var key = "question".concat(question.id); // check for answer in state and verify vaue an array, if not, create one

    if (!state.responses[key] || !Array.isArray(state.responses[key].value)) {
      Vue.set(state.responses, key, {
        id: question.id,
        value: [],
        question: question
      });
    } // clone current answer


    var answer = cloneDeep(state.responses[key]); // upsert new rating into the new answer
    // filter out all ratings matching the current ref

    answer.value = answer.value.filter(function (r) {
      return r.ref !== rating.ref;
    }); // push in new rating

    answer.value.push(rating); // this must be set in order for this type of answer to be detected by questions()

    answer.fromQuestion = true;
    answer.meta = _objectSpread(_objectSpread({}, question._meta), {}, {
      question: question
    }); // replace answer in responses in state

    Vue.set(state.responses, key, buildResponse(answer));
  },

  /**
   *
   * @param {Object} state vuex state
   * @param {Object} payload payload
   * @param {Object} payload.question mi question
   * @param {Object} payload.id product reference id
   *
   * @returns {Void}
   *
   */
  removeMenuInsightResponse: function removeMenuInsightResponse(state, _ref2) {
    var question = _ref2.question,
        id = _ref2.id;
    var key = "question".concat(question.id); // find current answer - if none, ditch out

    if (!state.responses[key] || Array.isArray(!state.responses[key].value)) {
      return;
    }

    var answer = cloneDeep(state.responses[key]); // filter out all ratings matching the current ref

    answer.value = answer.value.filter(function (r) {
      return r.ref !== id;
    }); // set answer in responses in state

    Vue.set(state.responses, key, answer);
  },
  setResponse: function setResponse(state, payload) {
    Vue.set(state.responses, payload.id, buildResponse(payload)); // we increment the count of responsesUpdated, because this is an easy and reliable thing to watch for changes (rather than watching for deep object changes). This is used for validation etc

    state.responsesUpdated++;
  },
  setRecommendSuggestionResponse: function setRecommendSuggestionResponse(state, payload) {
    state.recommendSuggestionResponse = payload;
  }
};
var actions = {
  /**
   *
   * @param {Object} context vuex context
   * @param {Object} payload payload
   * @param {Object} payload.question mi question
   * @param {Object} payload.rating mi rating
   *
   * @returns {Void}
   *
   */
  upsertMenuInsightResponse: function upsertMenuInsightResponse(_ref3, payload) {
    var commit = _ref3.commit;
    commit('setMenuInsightResponse', payload);
  },

  /**
   *
   * @param {Object} context vuex context
   * @param {Object} payload payload
   * @param {Object} payload.question mi question
   * @param {Object} payload.id product reference id
   *
   * @returns {Void}
   *
   */
  clearMenuInsightResponse: function clearMenuInsightResponse(_ref4, payload) {
    var commit = _ref4.commit;
    commit('removeMenuInsightResponse', payload);
  },
  setResponse: function setResponse(_ref5, payload) {
    var commit = _ref5.commit;
    commit('setResponse', payload);
  },
  getRecommendSuggestion: function getRecommendSuggestion(_ref6) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _rootGetters$response;

      var state, commit, rootGetters, submission, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = _ref6.state, commit = _ref6.commit, rootGetters = _ref6.rootGetters;

              if (!(state.recommendSuggestionResponse !== undefined)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", state.recommendSuggestionResponse);

            case 3:
              submission = (_rootGetters$response = rootGetters['responses/current'].results) === null || _rootGetters$response === void 0 ? void 0 : _rootGetters$response.submit;
              _context.next = 6;
              return _this.$api.fetchRecommendSuggestion({
                headers: {
                  responseId: submission === null || submission === void 0 ? void 0 : submission.id,
                  responseSecret: submission === null || submission === void 0 ? void 0 : submission.secret
                }
              });

            case 6:
              response = _context.sent;
              commit('setRecommendSuggestionResponse', response);
              return _context.abrupt("return", response);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
export default {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  namespaced: true
};